import BaseHandler from "./BaseHandler";
import { ErrorResponse } from "../proto/Error_pb";
import { memoryHistory } from "../index";
import Client from "../libs/Api/Client";
import { ROUTE_TOO_MANY_SESSION } from "../constants/routes";
import store from "../store";
import { setMultiSession } from "../store/messenger/actions";

export default class HandleErrorResponse extends BaseHandler<ErrorResponse> {
  handle() {
    const HandleErrorResponse = this.response.toObject();
    const isMultiTabError = HandleErrorResponse.majorCode === 3 && HandleErrorResponse.minorCode === 1;
    console.log("HandleErrorResponse", HandleErrorResponse);
    if (isMultiTabError) {
      Client.instance.close({ keepAlive: false });
      store.dispatch(setMultiSession(true));
      memoryHistory.push(ROUTE_TOO_MANY_SESSION, { not_reloaded: true });
    }
  }
}
